import type { PlanResponse } from "../../state/api.types";
import { PlanComparisonFromComparisonTable } from "../PlanComparisonTable/PlanComparisonTable";
import { usePlanComparison } from "../PlanComparisonTable/common";
import type { ServiceTerritory, UsageKwh } from "../PlanEditPage/common";

type PlanComparisonTableProps = {
  plan: PlanResponse;
  serviceTerritory: ServiceTerritory;
  planComparison: ReturnType<typeof usePlanComparison>;
  usageKwh?: UsageKwh;
  economicsOnly?: boolean;
};

export const PlanComparisonTable = ({
  plan,
  serviceTerritory,
  planComparison,
  usageKwh,
  economicsOnly,
}: PlanComparisonTableProps) => {
  return (
    <PlanComparisonFromComparisonTable
      plan={plan}
      serviceTerritory={serviceTerritory}
      planComparison={planComparison}
      usageKwh={usageKwh}
      economicsOnly={economicsOnly}
    />
  );
};
